import React from "react";

import Input from "../../../controls/Input";
import SelectMenu from "../../../controls/SelectMenu";
import DatePickerInput from "../../../controls/DatePickerInput";
import { formatDate } from "../../../../shared/utility";

const FIELD_CONTROL_CLASS =
  "block w-full min-h-[2.5rem] rounded-xl border border-[#E2E8F0] bg-white px-3 py-2 text-sm text-[#0F172A] shadow-sm transition focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10";

function LocationAndRoomFields({
  errors,
  handleInputChange,
  locationOptions,
  productionRoomOptions,
  values,
  wideLayout = false,
}) {
  const locationField = (
    <SelectMenu
      handleInputChange={handleInputChange}
      name="location"
      options={locationOptions}
      value={values.location}
      title="Location"
      error={errors.location}
      placeholder="Select location…"
    />
  );

  const productionRoomField = (
    <SelectMenu
      handleInputChange={handleInputChange}
      name="production_room"
      options={productionRoomOptions}
      value={values.production_room}
      title="Production room"
      error={errors.production_room}
      disabled={!values.location?.value}
      placeholder={
        values.location?.value
          ? "Select production room…"
          : "Select location first…"
      }
    />
  );

  if (wideLayout) {
    return (
      <>
        <div className="col-span-1">{locationField}</div>
        <div className="col-span-1">{productionRoomField}</div>
      </>
    );
  }

  return (
    <>
      <div className="col-span-2">{locationField}</div>
      <div className="col-span-2">{productionRoomField}</div>
    </>
  );
}

export default function ManufactureNewDetails(props) {
  const {
    certifiedByOptions,
    employeeOptions,
    supervisorOptions,
    claimsOptions,
    locationOptions = [],
    productionRoomOptions = [],
    errors,
    handleInputChange,
    values,
    wideLayout = false,
  } = props;

  if (wideLayout) {
    return (
      <div className="grid grid-cols-4 gap-4">
        <div className="col-span-1">
          <DatePickerInput
            label="Production date"
            name="production_date"
            onChange={handleInputChange}
            value={formatDate(values.production_date)}
            labelOn={true}
            type="text"
            dateFormat={"LLL dd, YYY"}
            classes={FIELD_CONTROL_CLASS}
            error={errors.production_date}
          />
        </div>
        <div className="col-span-1">
          <SelectMenu
            handleInputChange={handleInputChange}
            name="supervisor"
            options={supervisorOptions}
            value={values.supervisor}
            title={"Supervisor"}
            error={errors.supervisor}
          />
        </div>
        <div className="col-span-2">
          <SelectMenu
            handleInputChange={handleInputChange}
            isMulti={true}
            name="employee_1"
            options={employeeOptions}
            value={values.employee_1}
            title={"Employee"}
            error={errors.employee_1}
          />
        </div>
        <div className="col-span-1">
          <SelectMenu
            handleInputChange={handleInputChange}
            name="claims"
            options={claimsOptions}
            value={values.claims}
            title={"Claims"}
            showLabel={true}
            isMulti={true}
          />
        </div>
        <div className="col-span-1">
          <SelectMenu
            handleInputChange={handleInputChange}
            name="certification_type"
            options={certifiedByOptions}
            value={values.certification_type}
            title={"Certified by"}
            showLabel={true}
          />
        </div>
        <LocationAndRoomFields
          errors={errors}
          handleInputChange={handleInputChange}
          locationOptions={locationOptions}
          productionRoomOptions={productionRoomOptions}
          values={values}
          wideLayout
        />
        <div className="col-span-1">
          <Input
            label="Production Room Temp &deg;C"
            name="production_room_temperature"
            onChange={handleInputChange}
            value={values.production_room_temperature}
            labelOn={true}
            type="text"
            className={FIELD_CONTROL_CLASS}
            error={errors.production_room_temperature}
          />
        </div>
        <div className="col-span-1">
          <Input
            label="Raw Product Temp &deg;C"
            name="raw_product_temperature"
            onChange={handleInputChange}
            value={values.raw_product_temperature}
            labelOn={true}
            type="text"
            className={FIELD_CONTROL_CLASS}
            error={errors.raw_product_temperature}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 card-custom">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <div className="col-span-2">
          <SelectMenu
            handleInputChange={handleInputChange}
            name="supervisor"
            options={supervisorOptions}
            value={values.supervisor}
            title={"Supervisor"}
            error={errors.supervisor}
          />
        </div>
        <div className="col-span-2">
          <SelectMenu
            handleInputChange={handleInputChange}
            isMulti={true}
            name="employee_1"
            options={employeeOptions}
            value={values.employee_1}
            title={"Employee"}
            error={errors.employee_1}
          />
        </div>
        <div className="col-span-2">
          <SelectMenu
            handleInputChange={handleInputChange}
            name="claims"
            options={claimsOptions}
            value={values.claims}
            title={"Claims"}
            showLabel={true}
            isMulti={true}
          />
        </div>
        <div className="col-span-1">
          <SelectMenu
            handleInputChange={handleInputChange}
            name="certification_type"
            options={certifiedByOptions}
            value={values.certification_type}
            title={"Certified by"}
            showLabel={true}
          />
        </div>
        <LocationAndRoomFields
          errors={errors}
          handleInputChange={handleInputChange}
          locationOptions={locationOptions}
          productionRoomOptions={productionRoomOptions}
          values={values}
        />
        <div className="col-span-1">
          <Input
            label="Production Room Temp &deg;C"
            name="production_room_temperature"
            onChange={handleInputChange}
            value={values.production_room_temperature}
            labelOn={true}
            type="text"
            className={FIELD_CONTROL_CLASS}
            error={errors.production_room_temperature}
          />
        </div>
        <div className="col-span-1">
          <Input
            label="Raw Product Temp &deg;C"
            name="raw_product_temperature"
            onChange={handleInputChange}
            value={values.raw_product_temperature}
            labelOn={true}
            type="text"
            className={FIELD_CONTROL_CLASS}
            error={errors.raw_product_temperature}
          />
        </div>
      </div>
    </div>
  );
}
